export default {
    topWindow: {
        seriesS: 'S系列',
        support: '技术支持',
        contact: '联系我们'
    },
    footWindow: {
        seriesS: 'S系列',
        support: '技术支持',
        contact: '联系我们',
        about: '关于太势',
        understand: '选购及了解',
    },
    home: {
        s_arrived: 'S系来了',
        power: '超强悍。',
        buy: '购买',
        learnMore: '进一步了解'
    },
    series: {
        delight: '动心更称心',
        power: '强悍的强',
        power_text1: '我们迄今最强的多层裁床S系列来了。',
        power_text2: '搭载全新的EVOLUTION操作软件，',
        power_text3: '集合边走边裁和刀智能纠偏（ICC）等先进功能,带来裁剪质量和效率的颠覆性提升。',
        power_text4: '6000rpm振动箱，高速稳定。高强度钢结构床身，经历100万次真空吸附测试，坚不可摧。',
        power_text5: 'GALAXY Mars55真空风机，45kw超高功率，带来无以伦比的真空吸附。',
        power_text6: '隐藏式消音器，收料区开阔无遮挡。一款强悍又独树一帜的裁床由此诞生。',
        power_text7: '这个S系列裁床，就是个强悍的猛兽。',
        punching: '单打孔',
        double_punching: '双打孔',
        two_height: '两种裁剪高度。',
        MaxCuttingThickness: '最高裁剪厚度',
        threeWidth: '三种宽度',
        maxCuttingWidth: '最宽裁剪区域',
        twoLength: '两种长度。',
        twoKnife: '2种裁刀。',
        cuttingRoom: '你的下一台裁床，',
        chimney: '何必有个碍事的大烟囱？',
        concealed: '专利独创的',
        misChimney: '“烟囱”消失术 ',
        chimney_right_text1: '消音器与床身融合式设计，不但加强了',
        chimney_right_text2: '床身结构强度，更在检查裁剪和收料时，',
        chimney_right_text3: '视线一览无余，台面清爽干净。',
        unbreakable: '了不得。',
        tank: '这台机器坚固得像一辆坦克。',
        tank_desc: '得益于为国际顶级品牌裁床公司提供设计和制造服务的17年经验，',
        tank_desc1: '我们设计并制造出了这个坚固如坦克般的怪物床身，',
        tank_desc2: '高强度结构设计和世界顶端的制造工艺，',
        tank_desc3: '使太势裁床床身可经受-25kpa真空，连续100万次循环耐压测试',
        tank_desc4: '无焊缝脱落和变形，坚不可摧。',
        heatwave: '夏天温度过高？',
        battleReady: '尽管飙，全天奉陪',
        heat_desc: '0.75kw强制循环风冷，',
        heat_desc1: '为真空吸附系统强劲散热。',
        heat_desc2: '结构型材内腔进出气。',
        heat_desc3: '床身无可视散热孔，',
        heat_desc4: '真空吸附噪音完全封闭。',
        galaxy_desc1: '漏气吸不住？',
        galaxy_desc2: '放马过来。',
        galaxy_desc3: 'Galaxy Mars 50/55',
        galaxy_desc4: '多级离心真空风机',
        galaxy_desc5: '集多项专利于一身，',
        galaxy_desc6: '国际顶级品牌裁床的一致选择。',
        galaxy_desc7: '不光稳定可靠，',
        galaxy_desc8: '更专注于大流量下的真空保持，',
        galaxy_desc9: '裁剪漏气一样吸得牢。',
        vacuum: '吸附力MAX，',
        match_vacuum: '更可搭配多种功率组合。',
        motor: '电机',
        saturn: '土星系列单级高速离心真空泵',
        saturn_desc1: '我也有多种功率组合…',
        saturn_desc2: '永磁同步高速电机',
        saturn_desc3: '最高 24,000 rpm<',
        saturn_desc4: '真空可达 -25 kpa',
        saturn_desc5: '磁悬浮永磁高速电机',
        saturn_desc6: '最高 200,000 rpm',
        saturn_desc7: '真空可达 -40 kpa',
        saturn_desc8: '(其实用不着这么高…)',
        saturn_desc9: '星云 系列 中央真空系统',
        saturn_desc10: '针对特定工艺和大规模制造工厂。',
        saturn_desc11: '无需再覆膜，永久恒定真空。',
        saturn_desc12: '过滤器堵塞不再影响真空。',
        saturn_desc13: '更安全，更环保。',
        saturn_desc14: '真正的节能方案，2年电费省下一台裁床。',
        max_flow: '最大流量',
        max_vacuum: '最大真空',
        Competitor: '其他品牌',
        max_flow_vacuum: '最大流量下真空',
        clogged_filter: '过滤器堵了吸不住？',
        try_me: '换我试试。',
        vacuum_desc1: '大势独有的，带滤筒(芯)清洁提示的，',
        vacuum_desc2: '旋风+滤筒 2合1 过滤器。',
        vacuum_desc3: '极大减少过滤器堵塞对真空吸附的影响，',
        vacuum_desc4: '大大延长清洁周期。',
        extendedCleaning: '清洁周期延长',
        impactFilterClogging: '滤网影响吸附',
        clogging_other: '其他品牌',
        sandingBelts: '我们的磨刀比砂带磨刀好在哪？',
        sharpTime: '0.7秒',
        sharpTimeDesc: '完成磨刀，快如闪电。',
        sharpWidth: '刀宽检测，',
        sharpWidthDesc: '让裁剪精度更上层楼。',
        sharpBelts: '相比砂带，',
        sharpBeltsDesc: '砂轮磨出的刀刃更平直。',
        sharpKnife: '砂轮凹磨刀刃更锋利，',
        sharpKnifeDesc: '刀背更宽不易断刀。',
        vibration: '太势S振动箱',
        vibration_fast: '快得吓人。',
        vibration_rpm: '6000 rpm',
        vibration_desc: '专利振动箱如常规机械齿轮箱的开合设计方式，便于内部运动组件安装及更换。\n' +
            '旋转部件ISO G2.5动平衡，使S振动箱可完全消除一阶振动。',
        evolution_system: '这么强大？',
        evolution_try: '我想试试。',
        evolution_desc1: 'S6/9裁床',
        evolution_desc2: '搭载迄今为止',
        evolution_desc3: '太势力最先进的裁剪操作系统',
        evolution_desc4: '软著号 2025SR0494189',
        evolution_desc5: '有EVOLUTION裁剪操作系统坐镇，',
        evolution_desc6: '让太势力裁床操作简便，使用安全，',
        evolution_desc7: '精准高效，火力全开。',
        fly_cutting: '边走边裁，',
        fly_cutting2: '边走，边裁。',
        fly_cutting3: '过窗中随着面料移动持续裁剪，裁剪效率得颠覆性提升。',
        fly_cutting4: '边走边裁',
        fly_cutting5: '快得太吓人。',
        fly_cutting6: '最快达',
        fly_cutting7: '1.3倍',
        fly_cutting8: '裁剪缩短时间',
        banner_one_text1: '面料上下，',
        banner_one_text2: '分毫不差，',
        banner_one_text3: '透着超级范。',
        banner_one_text4: '太势S系裁床 搭载',
        banner_one_text5: '高效刀智能纠偏装置',
        banner_one_text6: '与众不同的刀智能机构，使太势裁床在高层裁剪中，',
        banner_one_text7: '时刻保持',
        banner_one_text8: '裁刀垂直切割',
        banner_second_text1: '智能对称裁功能。',
        banner_second_text2: '深V或者对称图形自动识别，自动对称下刀。',
        banner_second_text3: '深V不伤片，裁片对称就是这么省心。',
        banner_three_text1: '小间隙裁剪',
        banner_three_text2: '得心应手',
        banner_three_text3: '太势智能压刀功能',
        banner_three_text4: '智能压刀未开启',
        banner_three_text5: '智能压刀开启后',
        banner_four_text1: '小裁片裁不好？',
        banner_four_text2: '我来搞定。',
        banner_four_text3: '大片先裁后，真空吸附力减弱，',
        banner_four_text4: '容易造成小裁片裁剪质量下降。',
        banner_four_text5: '太势EVO裁剪系统，',
        banner_four_text6: '自动优化裁剪顺序，',
        banner_four_text7: '分区优先裁剪小裁片，窄裁片。',
        banner_four_text8: '同时智能优化下刀点和裁剪方向。',
        banner_four_text9: '裁片靠得再近，',
        banner_four_text10: '变换下刀提刀位置也不伤片，',
        banner_four_text11: '这个系统就是这么机智。',
        banner_five_text1: '该快 快，',
        banner_five_text2: '该慢 慢，',
        banner_five_text3: '滴水不漏。',
        banner_five_text4: '太势EVO系统搭载',
        banner_five_text5: '临片减速&临边减速功能。',
        banner_five_text6: '相邻裁片之间，',
        banner_five_text7: '或是临近布料边缘，',
        banner_five_text8: '可自动开启减速精裁。',
        banner_six_text1: '断点续裁，',
        banner_six_text2: '在断点，续裁。',
        banner_six_text3: '按键暂停，触发急停或断(停)电后，',
        banner_six_text4: 'EVO裁剪系统可在暂停断点衔接续裁，',
        banner_six_text5: '无需将此裁片已裁剪的部分再裁一遍。',
        malfunction_text1: '故障吗？',
        malfunction_text2: '怎么办？',
        malfunction_text3: '别着急，',
        malfunction_text4: '跟着故障排除向导做，',
        malfunction_text5: '故障排除，轻而易举。',
        malfunction_text6: ' 你自己就是维修专家。',
        maintenance_text1: '来，自己动手做保养。',
        optional_title: '选配？全都有。',
        optional_title2: '你的工艺难题，统统破解。',
        SingleDrill: '气动单打孔',
        DualDrill: '气动双打孔',
        SmartFeedingSystem: '太势SmartFeeding智能进料辅助系统',
        CenteringTracker: '随动居中小车',
        SaasAccess: 'SaaS接入',
        KnifeCooling: '涡流管刀冷却',
        Pre_Film: 'Pro型覆膜前支架',
        Secondary: 'Pro型再覆膜',
        Vacuum: '强劲真空系列',
        Scanner: '扫码枪',
        BrokenKnife: '断刀检测',
        Floating: '刀盘悬浮',
        Relocating: '侧移一键到位',
        knife_desc: '刀盘悬浮，',
        knife_desc1: '独一无二。',
        knife_desc2: '太势S系列可选配',
        knife_desc3: '刀盘悬浮功能。',
        knife_desc4: '根据预设悬浮高度，',
        knife_desc5: '自适应调整',
        knife_desc6: '刀盘离开面料悬浮高度。',
        knife_desc7: '避免裁剪特殊面料时，',
        knife_desc8: '刀盘推动顶层面料',
        knife_desc9: '或者产生静电。',
        recoating_desc1: '再覆膜？我也有。（选配）',
        recoating_desc2: '太势S系列可选配随动再覆膜装置，',
        recoating_desc3: '过窗自动抬起覆膜，连续裁剪无需手动干涉。',
        recoating_desc4: '鱼与熊掌，亦可得兼，',
        recoating_desc5: '高速裁剪+随动再覆膜保持真空，',
        recoating_desc6: '2种强大能力，互不干涉，相辅相成，',
        recoating_desc7: '既快又省心，就是不一般。',
        barcode_scanner: '扫码枪？安排。',
        barcode_scanner2: '（选配）',
        power_supply: '电源能耗及工作环境',
        Dimensions: '外形尺寸',
        products_one_desc1: '太势 S6自动裁床',
        products_one_desc2: '精益求精之选',
        products_one_desc3: '最大裁剪高度',
        products_one_desc4: '有效裁剪区长度',
        products_one_desc5: '裁刀尺寸',
        products_one_desc6: '-标准真空包(可选)',
        products_one_desc7: '标准真空包',
        products_one_desc8: '太势 S9自动裁床',
        products_one_desc9: '均衡强劲之选',
        products_one_desc10: '太势 S9自动裁床(MAX)',
        products_one_desc11: '事半功倍之选',
        bed_data_desc1: '最大裁剪速度',
        bed_data_desc2: '最高刀频',
        bed_data_desc3: '11 kWh平均能耗',
        bed_data_desc4: '(基于特定工艺)',
        bed_data_desc5: '工作台面高度(可调)',
        bed_data_desc6: '3700 kg 整备质量',
        bed_data_desc7: '(1818型)',
        new: '新品牌，不敢用？',
        old: '虽然看起来是新面孔，但我们都是老鸟。',
        contact_one: '江苏省，常州市，新北区',
        contact_two: '华平(常州)智造园-C2',
    }
}
